module.exports = __webpack_public_path__ + "static/media/17UN-Women4.e98f6d49.jpg";